<template>
  <wrapper>
    <main class="main-content-wrapper">
      <card>
        <div class="row">
            <div class="col-lg-4">
            Item Code
            <input
                type="text"
                name=""
                class="form-control"
                placeholder="Item Code"
                v-model="searchItemCode"
            />
            </div>
            <div class="col-lg-4">
                Part Name
                <input
                    type="text"
                    name=""
                    class="form-control"
                    placeholder="Part Name"
                    v-model="searchPartName"
                />
            </div>
            <div class="col-lg-4">
            Product Status
            <multiselect
                v-model="searchStatus"
                :options="statusOptions"
                label="statusName"
                :allow-empty="false"
                :select-label="'Type'"
                :deselect-label="''"
                placeholder="Select Status"
                track-by="statusName"
            ></multiselect>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-4">
        <div>
          <button
            class="btn btn-primary default-btn"
            @click="searchData()"
          >
            Search
          </button>
        </div>
        <div>
          <button
            class="btn reset-btn default-btn ml-2"
            @click="resetSearch()"
          >
            Reset
          </button>
        </div>
        </div>
      </card>
      <br />
      <table
        class="table table-sm table-bordered table-striped table-responsive-sm"
      >
        <thead class="">
          <tr>
            <th style="text-align: center;">Item Code</th>
            <th style="text-align: center;">Part Name</th>
            <th style="text-align: center;">Status</th>
            <th style="text-align: center; width: 150px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loadingTable === false && totalData == '0'">
            <td colspan="4" class="text-center">Data Not Available</td>
          </tr>
          <tr v-else-if="loadingTable === true">
            <td colspan="4" class="text-center">
              <img src="~@/assets/images/load-button.gif" />
            </td>
          </tr>
          <tr
            v-for="(data, index) in dataCatalog"
            v-else
            :key="`catalog-${index}`"
          >
            <td>{{ data.itemCode }}</td>
            <td>{{`${data.itemGroup} - ${data.itemName}`}}</td>
            <td>
              <label class="badge badge-success" v-if="data.status == 1"
                >Set</label
              >
              <label
                class="badge badge-secondary"
                v-if="data.status == 2"
                >Not Set</label
              >
            </td>
            <td>
              <div class="d-flex justify-content-center" style="gap: 5px">
                <button
                  class="btn icon-btn icon-btn-blue"
                  @click="toPartCompabilityDetail(data)"
                >
                  <img src="~@/assets/icon/eye-blue.svg" alt="eye icon">
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <div style="margin-right: 10px">
            <select
              class="form-control form-control-sm"
              v-model="itemPerPage"
              @change="toDataPerPage(itemPerPage)"
            >
              <option value="10">10</option>
              <option value="40">40</option>
              <option value="80">80</option>
            </select>
          </div>
          <div class="total-data align-self-center">
            Total Data {{ totalData }}
          </div>
        </div>
        <div>
          <div class="pagination p8 alignRight">
            <ul>
              <a
                class="is-active link"
                @click="toDataPage(parseInt(currentPage) - 1)"
                v-if="currentPage != 1"
              >
                <li>
                  {{ "<" }}
                </li>
              </a>
              <a class="page">
                <li>{{ currentPage }} of {{ totalPage }} page</li>
              </a>
              <a
                class="is-active link"
                @click="toDataPage(parseInt(currentPage) + 1)"
                v-if="currentPage != totalPage"
              >
                <li>{{ ">" }}</li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </main>
    <!-- /#page-content-wrapper -->
  </wrapper>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SideBar from "../SideBar";
import { Wrapper, Card } from "../Layout";

export default {
  name: "PartCompabilityPage",
  components: {
    SideBar,
    Multiselect,
    Wrapper,
    Card,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      dataCatalog: [],
      statusOptions:[
        {
          status: 0,
          statusName : 'All',
        },
        {
          status: 1,
          statusName : 'Set'
        },
        {
          status: 2,
          statusName : 'Not Set'
        }
      ],
      searchStatus: {
        status: 0,
        statusName : "All"
      },
      searchPartName: "",
      searchItemCode: "",
      admin: "",
      adminId: "",

      permission: [],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPartCompatiblity : false,
      deletePartCompatibility : false,
      editPartCompatibility : false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      loadingButtonNext: false,
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      loadingTable: false,
      itemPerPage: 10,
    };
  },
  methods: {
    toPartCompabilityDetail(data) {
      console.log(data)
      this.$router.push({
        path: "/catalog/part-compatibility/detail/" + data.itemCode,
        query: {
          itemName : data.itemName,
          itemGroup : data.itemGroup,
        }
      });
    },

    resetSearch() {
      this.searchPartName = "";
      this.searchItemCode = "";
      this.searchStatus = { status: 0, statusName: "All" };
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.searchData();
    },

    searchData() {
      this.$router.push(
        {
          path:'/catalog/part-compatibility', 
          query: {
            itemCode: this.searchItemCode,
            partName: this.searchPartName,
            status: this.searchStatus.status,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPage(pagePost) {
      this.$router.push(
        {
          path:'/catalog/part-compatibility', 
          query: {
            itemCode: this.searchItemCode,
            partName: this.searchPartName,
            status: this.searchStatus.status,
            page: pagePost,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPerPage() {
      this.$router.push(
        {
          path:'/catalog/part-compatibility', 
          query: {
            itemCode: this.searchItemCode,
            partName: this.searchPartName,
            status: this.searchStatus.status,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },

    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if(this.permission[i] == "4.5") {
          this.viewPartCompatiblity = true
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
      }
      if (this.viewPartCompatiblity == false) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id) {
      this.$router.push("/product/detail/" + id);
    },
    async getData() {
      try {
        this.loadingTable = true;
        this.searchPartName = this.$route.query.partName;
        this.searchItemCode = this.$route.query.itemCode
        this.searchStatus = this.statusOptions.find(item => item.status == this.$route.query.status);
        this.currentPage = parseInt(this.$route.query.page);
        this.itemPerPage = parseInt(this.$route.query.itemPerPage);
        const response = await this.$http.post(
          process.env.SEARCH_PART_COMPABILITY_LIST,
          {
            itemCode: this.searchItemCode,
            partName: this.searchPartName,
            status: this.searchStatus.status, // 0 : all , 1 : set only,2 :not set only
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status == 400) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          this.loadingTable = false;
          // this.handleLogout();
        } else {
          if(response.data.status === 200) {
            this.dataCatalog = response.data.content.data;
            this.totalPage = response.data.content.totalPage;
            this.currentPage = response.data.content.currentPage;
            this.totalData = response.data.content.totalData;
            this.loadingTable = false;
          } else {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            }).then((v) => {

            })
            this.loadingTable = false;
          }
          
           
        }
      } catch (error) {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then((v) => {
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      }
    },

    sendLog(x, y) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      var productName =
        this.productNameChoose == null
          ? this.productNameChoose
          : this.productNameChoose.replace(this.spaceRegex, " ");
      if (y == "34") {
        var newShowing = this.showingChoose;
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName, newShowing],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
    await this.getData();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.text-main-color {
  color: #2E3646;
}

.default-btn {
  font-weight: 600;
  height: fit-content;
  font-size: .875rem;
  padding: .5rem .75rem;
  border-radius: .375rem;
}

.icon-btn {
  border-radius: 8px;
  padding: 4px;
  background: #ffffff;
  width: 34px;
}

.icon-btn-blue {
  border: 1px solid #247FEC66;
}

.icon-btn-orange {
  border: 1px solid #F2641966;
}

.icon-btn-red {
  border: 1px solid #FF344480;
}

.icon-btn-green {
  border: 1px solid #C8DFCA;
}

.reset-btn {
  border: 1px solid #D1D9E2;
  color: #2E3646;
}

.field-label {
  width: 160px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797fb;
  color: #fff;
  border: 1px solid #2797fb;
}

.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}

.total-data {
  font-size: 14px;
  color: #343a40;
}

.right-dropdown {
  margin-left: 7px;
}

.main-content-wrapper {
  padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalog/PartCompabilityPage.vue